import React, { FC, useMemo } from 'react';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import SearchableSelect, {
  SearchableSelectItem,
  SelectOption,
} from 'components/inputs/SearchableSelect';
import { CarTransportTruck } from 'api/model';
import { useCarTransportTruckList } from 'api/car-transport-truck/car-transport-truck';
import { DropdownPosition } from './Dropdown';

export const StyledTruckSelectItem = styled(SearchableSelectItem)<{
  isNoneItem?: boolean;
}>`
  ${({ isNoneItem }) =>
    isNoneItem &&
    css`
      font-style: italic;
    `}// ...existing styling if any...
`;

function optionRender(
  key: string,
  option: SelectOption<number | null, CarTransportTruck | null>,
  onClick: () => void,
  isSelected: boolean
) {
  return (
    <StyledTruckSelectItem
      isNoneItem={option.value === null}
      key={key}
      onClick={onClick}
      selected={isSelected}
    >
      {option.label}
    </StyledTruckSelectItem>
  );
}

interface Props {
  selectedCarTransportTruckId: number | null;
  onCarTransportTruckSelected(truck: CarTransportTruck | null): void;
  disabled?: boolean;
  hideInput?: boolean;
  dropdownPosition?: DropdownPosition;
  itemsWrapperStyle?: FlattenSimpleInterpolation;
  // Optional custom renderer
  renderItem?: (
    key: string,
    option: SelectOption<number | null, CarTransportTruck | null>,
    onClick: () => void,
    isSelected: boolean
  ) => React.ReactNode;
}

const CarTransportTruckPicker: FC<Props> = ({
  selectedCarTransportTruckId,
  onCarTransportTruckSelected,
  disabled,
  hideInput,
  dropdownPosition,
  itemsWrapperStyle,
  renderItem,
}) => {
  const carTransportTrucksListCall = useCarTransportTruckList();

  const handleOptionClicked = (
    _truckId: number | null,
    _selected: boolean,
    option: SelectOption<number | null, CarTransportTruck | null>
  ) => {
    onCarTransportTruckSelected(option.extra);
  };

  const options = useMemo((): SelectOption<
    number | null,
    CarTransportTruck | null
  >[] => {
    const opts = (carTransportTrucksListCall.data ?? []).map((truck) => ({
      label: `${truck.registrationNumber} (${truck.maxNumberOfCars} bilar)`,
      value: truck.id,
      extra: truck,
    })) as SelectOption<number | null, CarTransportTruck | null>[];
    opts.unshift({
      label: 'Välj lastbil',
      value: null,
      extra: null,
    });
    return opts;
  }, [carTransportTrucksListCall.data]);

  return (
    <SearchableSelect
      disabled={disabled}
      hideInput={hideInput}
      dropdownPosition={dropdownPosition}
      itemsWrapperStyle={itemsWrapperStyle}
      onOptionClicked={handleOptionClicked}
      optionRender={renderItem || optionRender}
      options={options}
      searchFilter={(searchString, opts) => {
        const lowerSearch = searchString.toLowerCase();
        return opts.filter(
          (opt) =>
            opt.value === null ||
            (opt.extra &&
              opt.extra.registrationNumber &&
              opt.extra.registrationNumber
                .toLowerCase()
                .includes(lowerSearch)) ||
            (opt.extra && opt.extra.maxNumberOfCars === Number(searchString))
        );
      }}
      selectedValue={selectedCarTransportTruckId}
    />
  );
};

export default CarTransportTruckPicker;

// ...existing code if any...
